import * as STD                               from '@emersya/mpa-std';
import * as CM                                from '@emersya/mpa-components-manager';
import {
	Block,
	Text,
	InputButton
}                                             from '@emersya/mpa-components';

export interface IPlannerFurnitureComponentConfiguration extends CM.DOMComponent.IConfiguration {
	searchBar: boolean;
	countFurniture: boolean;
	typeFilter : string | null;
};

export class PlannerFurnitureComponent extends CM.DOMComponent<
	HTMLDivElement,
	PlannerFurnitureComponent,
	IPlannerFurnitureComponentConfiguration
> {
	categoryTileId: string = 'viewer-planner-furniture-categoryTile';
	productTileId: string = 'viewer-planner-furniture-categoryTile';

	static override initialize() {
		super.initialize();
	};

	component_DOM: HTMLDivElement;

	get categories() {
		const menu = this.component_find('@:menu');
		return <PlannerFurnitureCategoryTile.Component[]>menu.component_outerChilds;
	};

	getWDH() {
		const p = app.currentProduct;
		if (!p) {
			this.component_throwUserError('', {});
		}
		const dpart = p.getPart(['dimensions']);
		return {
			width: Number.parseFloat(dpart.getPart(['width'])?.reference?.value || <string><any>1),
			depth: Number.parseFloat(dpart.getPart(['depth'])?.reference?.value || <string><any>1),
			height: Number.parseFloat(dpart.getPart(['height'])?.reference?.value || <string><any>1)
		};
	};

	researchUpdate(ev: STD.events.Event<any, CM.Component<any, any>>) {
		if (this.component_configuration.countFurniture) {
			this.researchUpdateWithCount(ev);
		} else {
			this.researchUpdateWithoutCount(ev);
		}
	};

	researchUpdateWithCount(ev: STD.events.Event<any, CM.Component<any, any>>) {
		const searchTerms = ev.details.newValue?.toLowerCase().split(' ').filter((term: string) => term.length > 0);

		const menu = this.component_find('@:menu');
		menu.component_outerChilds.forEach(categorie => {
			const content = categorie.component_find('@:content');
			const totalCountTitle = <Text.Component>categorie.component_find('@:header.blockTitle.componentsCount');
			const currentCountTitle = <Text.Component>categorie.component_find('@:header.blockTitle.currentCount');
			if (!searchTerms) {
				content.component_outerChilds.forEach(element => {
					(<InputButton.Component>element).component_DOM.classList.remove('notDisplayed');
				});
				totalCountTitle.component_DOM.classList.remove('notDisplayed');
				currentCountTitle.component_DOM.classList.add('notDisplayed');
				return;
			}
			let count = 0;
			content.component_outerChilds.forEach(element => {
				const id = element.id.toLowerCase();
				if (searchTerms.every((term: string) => id.includes(term))) {
					count += 1;
					(<InputButton.Component>element).component_DOM.classList.remove('notDisplayed');
				} else {
					(<InputButton.Component>element).component_DOM.classList.add('notDisplayed');
				}
			});
			totalCountTitle.component_DOM.classList.add('notDisplayed');
			currentCountTitle.component_DOM.classList.remove('notDisplayed');
			currentCountTitle.component_DOM.innerText = '(' + count.toString() + ')';
		});
	};

	researchUpdateWithoutCount(ev: STD.events.Event<any, CM.Component<any, any>>) {
		const searchTerms = ev.details.newValue?.toLowerCase().split(' ').filter((term: string) => term.length > 0);

		const menu = this.component_find('@:menu');
		menu.component_outerChilds.forEach(categorie => {
			const content = categorie.component_find('@:content');
			if (!searchTerms) {
				content.component_outerChilds.forEach(element => {
					(<InputButton.Component>element).component_DOM.classList.remove('notDisplayed');
				});
				return;
			}
			content.component_outerChilds.forEach(element => {
				const id = element.id.toLowerCase();
				if (searchTerms.every((term: string) => id.includes(term))) {
					(<InputButton.Component>element).component_DOM.classList.remove('notDisplayed');
				} else {
					(<InputButton.Component>element).component_DOM.classList.add('notDisplayed');
				}
			});
		});
	};

	override async component_initialize() {
		if (!this.component_configuration.searchBar) {
			const searchBarContainer = <Block.Component>this.component_find('@:searchBarContainer');
			searchBarContainer.component_DOM.classList.add('notDisplayed');
		}
		const menu = this.component_find('@:menu');
		const type = this.component_configuration.typeFilter ? this.component_configuration.typeFilter : '@furniture'; 
		const furnitureObjects = app.component_configuration.PMS.objects.filter(x => x.type === type);
		const productsInFunctionOfCategory = furnitureObjects.reduce<Record<string, typeof app.component_configuration.PMS.objects>>(
			(a, c) => {
				const category = c.categoryPath;
				if (!a[category]) {
					a[category] = [];
				}
				const store = a[category];
				if (!store) {
					throw new Error('!'); // Very bad, is impossible!!!
				}
				store.push(c);
				return a;
			},
			{}
		);
		for (const [catId, categoryContent] of Object.entries(productsInFunctionOfCategory)) {
			const categoryConfiguration = app.component_configuration.PMS.productsAndObjectsCategories[catId];
			if (!categoryConfiguration) {
				this.component_throwUserError('', {
					categoryId: catId
				});
			}
			const categoryComponent = <CM.DOMComponent<any, any, any>>await menu.component_instantiateOuterChild<PlannerFurnitureCategoryTile.Configuration>(
				{
					type: this.categoryTileId,
					id: catId,
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					configuration: {
						categoryConfiguration,
						objectsConfigurations: categoryContent,
						count: this.component_configuration.countFurniture,
						productTileId: this.productTileId
					}
				}
			);
			void categoryComponent;
		}
		await super.component_initialize();
	};

	/**
	 * Disable unused categories and enable used ones
	 * Update categories.
	 **/
	async update() {
		for (const category of this.categories) {
			await category.update();
		}
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IPlannerFurnitureComponentConfiguration
	) {
		configuration['@innerConfigurations'] = {};
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement>STD.DOM.factory({
			tag: 'div'
		});
	};
};
export namespace NS {
	export const Component = PlannerFurnitureComponent;
	export type Component = PlannerFurnitureComponent;
	export type Configuration = IPlannerFurnitureComponentConfiguration;
}
;
import manifestXMLSource                      from './PlannerFurnitureEditor.xml';
import './PlannerFurnitureEditor.scss';
import { NS as PlannerFurnitureCategoryTile } from '../CategoryTile/PlannerFurnitureCategoryTile';

CM.Manager.declare({
	id: 'viewer-planner-furniture-editor',
	type: PlannerFurnitureComponent,
	manifest: manifestXMLSource
});
